export default {
  LOGIN: '/login',
  REGISTER: '/register',
  HELP: '/help',
  SERVICE_ORDER_CREATE: '/service-request/create',
  SERVICE_ORDER_EDIT: (id) => {
    return `/service-request/${id}/edit`;
  },
  SERVICE_ORDER: '/service-request',
  SERVICE_ORDER_FREEPORT_CREATE: '/freeport-service-request/create',
  SERVICE_ORDER_FREEPORT: '/freeport-service-request',
  SERVICE_ORDER_FREEPORT_EDIT: (id) => {
    return `/freeport-service-request/${id}/edit`;
  },
  JOB_DESCRIPTION: '/job-description',
  WORK_ORDER_FORM: '/work-order/form',
  WORK_ORDER_DETAILS: (id) => {
    return `/work-order/${id}/detail`;
  },
  WORK_ORDER_DETAILS_FI: (id) => {
    return `/work-order-fi/${id}/detail-fi`;
  },
  WORK_ORDER_SUPPORT: (id) => {
    return `/work-order/${id}/support`;
  },
  WORK_ORDER_SERVICE_STATION: (id) => {
    return `/work-order/${id}/service-station`;
  },
  WORK_ORDER: '/work-order',
  WORK_ORDER_FI: '/work-order-fi',
  WORK_ORDER_PDF_ACTION: (id) => {
    return `/work-order-action/${id}/pdf`;
  },
  WORK_ORDER_PDF: (id) => {
    return `/work-order/${id}/pdf`;
  },
  WORK_ORDER_ESTIMATE_PDF: (id) => {
    return `/work-order-estimate/${id}/pdf`;
  },
  WORK_ORDER_STICKER: (id) => {
    return `/work-order/${id}/sticker`;
  },
  WORK_ORDER_QR_CODE_STICKER: (id) => {
    return `/work-order/${id}/qr-sticker`;
  },
  WORK_ORDER_INVOICE_PDF: (id) => {
    return `/work-order-invoice/${id}/pdf`;
  },
  WORK_ORDER_SIGNATURE: '/work-order-signature',
  WORK_ORDER_SIGNATURE_CREATE: '/work-order-signature/create',
  WORK_ORDER_SIGNATURE_EDIT: (id) => {
    return `/work-order-signature/${id}/edit`;
  },
  WORK_ORDER_KECIL_PDF: (id) => {
    return `/work-order-kecil/${id}/pdf`;
  },
  WAREHOUSE_WORK_ORDER: '/warehouse-work-order',
  WAREHOUSE_WORK_ORDER_FI: '/warehouse-work-order-fi',
  WAREHOUSE_WORK_ORDER_PDF: (id) => {
    return `/warehouse-work-order/${id}/pdf`;
  },
  WAREHOUSE_WORK_ORDER_DETAIL: (id) => {
    return `/warehouse-work-order/${id}/detail`;
  },
  WAREHOUSE_WORK_ORDER_DETAIL_FI: (id) => {
    return `/warehouse-work-order-fi/${id}/detail`;
  },
  POS_STATION: '/pos-station',
  POS_STATION_CREATE: '/pos-station/create',
  POS_STATION_UPLOAD: '/pos-station/upload',
  POS_STATION_EDIT: (id) => {
    return `/pos-station/${id}/edit`;
  },
  SHELF: '/shelves',
  SHELF_CREATE: '/shelves/create',
  SHELF_UPLOAD: '/shelves/upload',
  SHELF_EDIT: (id) => {
    return `/shelves/${id}/edit`;
  },
  SHELF_PDF: (id) => {
    return `/shelves/${id}/pdf`;
  },
  SHELF_DETAIL: (id) => {
    return `/shelves/${id}/detail`;
  },
  REQUEST_ITEM_APPROVAL: '/request-items-approval',
  REQUEST_ITEM: '/request-items',
  REQUEST_ITEM_OTHER: '/request-items-other',
  REQUEST_ITEM_BOS: '/request-items-report',
  REQUEST_ITEM_CREATE: '/request-items/create',
  REQUEST_ITEM_EDIT: (id) => {
    return `/request-items-other/${id}/edit`;
  },
  VENDOR: '/vendor',
  VENDOR_CREATE: '/vendor/create',
  VENDOR_UPLOAD: '/vendor/upload',
  VENDOR_EDIT: (id) => {
    return `/vendor/${id}/edit`;
  },
  JOB_RATES: '/job-rates',
  JOB_RATES_CREATE: '/job-rates/create',
  JOB_RATES_UPLOAD: '/job-rates/upload',
  JOB_RATES_EDIT: (id) => {
    return `/job-rates/${id}/edit`;
  },
  PM_CHECKS: '/pm-checks',
  PM_CHECKS_WAREHOUSE: '/pm-checks-warehouse',
  PM_CHECKS_WAREHOUSE_EDIT: (id) => {
    return `/pm-checks-warehouse/${id}`;
  },
  PM_CHECKS_ID: (id) => {
    return `/pm-checks/${id}/detail`;
  },
  PM_CHECKS_CREATE: '/pm-checks/create',
  PM_CHECKS_UPLOAD: '/pm-checks/upload',
  PM_CHECKS_EDIT: (id) => {
    return `/pm-checks/${id}/edit`;
  },
  PM_CHECKS_PDF: (id) => {
    return `/pm-checks/${id}/pdf`;
  },
  EMPLOYEES: '/employees',
  EMPLOYEES_CREATE: '/employees/create',
  EMPLOYEES_UPLOAD: '/employees/upload',
  EMPLOYEES_DETAIL: (id) => {
    return `/employees/${id}/detail`;
  },
  EMPLOYEES_EDIT: (id) => {
    return `/employees/${id}/edit`;
  },
  EMPLOYEES_PDF: (id) => {
    return `/employees/${id}/pdf`;
  },
  CLASSIFICATIONS: '/classification',
  CLASSIFICATIONS_CREATE: '/classification/create',
  CLASSIFICATIONS_EDIT: (id) => {
    return `/classification/${id}/edit`;
  },
  GRADES: '/grade',
  GRADES_CREATE: '/grade/create',
  GRADES_UPLOAD: '/grade/upload',
  GRADES_EDIT: (id) => {
    return `/grade/${id}/edit`;
  },
  DEPARTMENTS: '/department',
  DEPARTMENTS_CREATE: '/department/create',
  DEPARTMENTS_EDIT: (id) => {
    return `/department/${id}/edit`;
  },
  DEPARTMENTS_DETAIL: (id) => {
    return `/department/${id}/detail`;
  },
  POINT_OF_SALES: '/point-of-sales',
  POINT_OF_SALES_PDF: (id) => {
    return `/point-of-sales/${id}/pdf`;
  },
  POINT_OF_SALES_FO: '/point-of-sales-fo',
  POINT_OF_SALES_TOP: '/point-of-sales/top',
  SPARE_PARTS: '/spare-parts',
  SPARE_PARTS_UPLOAD: '/spare-parts/upload',
  SPARE_PARTS_CREATE: '/spare-parts/create',
  SPARE_PARTS_PDF: (id) => {
    return `/spare-parts/${id}/pdf`;
  },
  SPARE_PARTS_EDIT: (id) => {
    return `/spare-parts/${id}/edit`;
  },
  SPARE_PARTS_DETAIL: (id) => {
    return `/spare-parts/${id}/detail`;
  },
  SPARE_PARTS_SELLING_PRICE: (id) => {
    return `/spare-parts/${id}/selling-price`;
  },
  ASSETS: '/assets',
  ASSETS_UPLOAD: '/assets/upload',
  ASSETS_CREATE: '/assets/create',
  ASSETS_EDIT: (id) => {
    return `/assets/${id}/edit`;
  },
  CHARGE_APPROVAL: '/charge-approval',
  CHARGE_APPROVAL_CREATE: '/charge-approval/create',
  CHARGE_APPROVAL_DETAIL: (id) => {
    return `/charge-approval/${id}/detail`;
  },
  CHARGE_APPROVAL_EDIT: (id) => {
    return `/charge-approval/${id}/edit`;
  },
  CHARGE_APPROVAL_PDF: (id) => {
    return `/charge-approval/${id}/pdf`;
  },
  CHARGE_APPROVAL_SIGNATURE_CREATE: '/charge-approval/signature/create',
  CHARGE_APPROVAL_SIGNATURE_DETAIL: (id) => {
    return `/charge-approval/signature/${id}/detail`;
  },
  CHARGE_APPROVAL_SIGNATURE_EDIT: (id) => {
    return `/charge-approval/signature/${id}/edit`;
  },
  CHARGE_APPROVAL_SIGNATURE: '/charge-approval/signature',
  CONTRACTS: '/contracts',
  CONTRACTS_CREATE: '/contracts/create',
  CONTRACTS_EDIT: (id) => {
    return `/contracts/${id}/edit`;
  },
  CONTRACTS_EDIT_CHARGE_APPROVAL: (contractId, chargeApprovalId) => {
    return `/contracts/${contractId}/charge-approval/${chargeApprovalId}/edit`;
  },
  CONTRACTS_ADD_CHARGE_APPROVAL: (id) => {
    return `/contracts/${id}/charge-approval/add`;
  },
  CONTRACTS_DETAIL: (id) => {
    return `/contracts/${id}`;
  },
  CONTRACTS_CHARGE_APPROVAL_DETAIL: (id, chargeApprovalId) => {
    return `/contracts/${id}/charge-approval/${chargeApprovalId}`;
  },
  CONTRACTS_CONTRACTOR_ADD: '/contracts/contractors/create',
  CONTRACTS_CONTRACTOR_EDIT: (id) => {
    return `/contracts/contractors/${id}/edit`;
  },
  INVOICES: '/invoices',
  INVOICES_CREATE: '/invoices/create',
  INVOICES_EDIT: (id) => {
    return `/invoices/${id}/edit`;
  },
  INVOICES_DETAIL: (id) => {
    return `/invoices/${id}/detail`;
  },
  CAR_WASH: '/car-wash',
  CAR_WASH_EDIT: (id) => {
    return `/car-wash/${id}/edit`;
  },
  PURCHASE_ORDER_APPROVAL: '/purchase-order-approval',
  PURCHASE_ORDER_WO: '/purchase-order-wo',
  PURCHASE_ORDER_WO_CREATE: '/purchase-order-wo/create',
  PURCHASE_ORDER_WO_EDIT: (id) => {
    return `/purchase-order-wo/${id}/edit`;
  },
  PURCHASE_ORDER_WO_DETAIL: (id) => {
    return `/purchase-order-wo/${id}/detail`;
  },
  PURCHASE_ORDER: '/purchase-order',
  PURCHASE_ORDER_CREATE: '/purchase-order/create',
  PURCHASE_ORDER_EDIT: (id) => {
    return `/purchase-order/${id}/edit`;
  },
  PURCHASE_ORDER_DETAIL: (id) => {
    return `/purchase-order/${id}/detail`;
  },
  PURCHASE_ORDER_MANAGER: '/purchase-order-manager',
  PURCHASE_ORDER_MANAGER_CREATE: '/purchase-order-manager/create',
  PURCHASE_ORDER_MANAGER_EDIT: (id) => {
    return `/purchase-order-manager/${id}/edit`;
  },
  PURCHASE_ORDER_MANAGER_DETAIL: (id) => {
    return `/purchase-order-manager/${id}/detail`;
  },
  SALES: '/sales',
  SALES_CREATE: '/sales/create',
  SALES_EDIT: (id) => {
    return `/sales/${id}/edit`;
  },
  SALES_DETAIL: (id) => {
    return `/sales/${id}/detail`;
  },
  UNIT: '/unit',
  UNIT_DETAIL: (id) => {
    return `/unit/${id}/detail`;
  },
  UNIT_EDIT: (id) => {
    return `/unit/${id}/edit`;
  },
  NOTIFICATIONS: '/notifications',
  LOGGING: '/logging',
  ATTENDANCE_UPLOAD: '/attendance/upload',
  ATTENDANCE_DETAIL: (id) => {
    return `/attendance/${id}/detail`;
  },
  ATTENDANCE: '/attendance',
  PAYROLL_DETAIL: (id) => {
    return `/payroll/${id}/detail`;
  },
  PAYROLL_DETAIL_PDF: (id) => {
    return `/payroll/${id}/pdf`;
  },
  PAYROLL_UPLOAD: '/payroll/upload',
  PAYROLL: '/payroll',
  HOLIDAY_CREATE: '/payroll/holiday/create',
  HOLIDAY_EDIT: (id) => {
    return `/payroll/holiday/${id}/edit`;
  },
  ACCOUNTS: '/accounts',
  ACCOUNTS_CREATE: '/accounts/create',
  ACCOUNTS_EDIT: (id) => {
    return `/accounts/${id}/edit`;
  },
  ACCOUNTING_CREATE: '/accounting/create',
  ACCOUNTING_EDIT: (id) => {
    return `/accounting/${id}/edit`;
  },
  ACCOUNTING_DETAIL: (id) => {
    return `/accounting/${id}/detail`;
  },
  ACCOUNTING: '/accounting',
  VOUCHERS: '/accounting/vouchers',
  VOUCHERS_CREATE: '/accounting/vouchers/create',
  VOUCHERS_EDIT: (id) => {
    return `/accounting/vouchers/${id}/edit`;
  },
  SUPPORT_DOCS_EDIT: (id) => {
    return `/support_docs/${id}/edit`;
  },
  SUPPORT_DOCS: '/support_docs',
  TIME_SHEETS_EDIT: (id) => {
    return `/time-sheets/${id}/edit`;
  },
  TIME_SHEETS_UPLOAD: '/time-sheets/upload',
  TIME_SHEETS: '/time-sheets',
  REPORTS: '/reports',
  REPORTS_WAREHOUSE: '/reports-warehouse',
  REPORTS_FINANCE: '/reports-finance',
  REPORTS_HR: '/reports-hr',
  LINK_TREE_REQUEST_ITEMS_CREATE: '/link-tree/request-items/create',
  LINK_TREE_REQUEST_ITEMS_CREATE_ID: (id) => {
    return `/link-tree/detail/${id}/request-items/create`;
  },
  LINK_TREE_REQUEST_ITEMS: '/link-tree/request-items',
  LINK_TREE_REQUEST_ITEMS_ID: (id) => {
    return `/link-tree/detail/${id}/request-items`;
  },
  LINK_TREE_WORK_ORDER_CREATE: '/link-tree/work-orders/create',
  LINK_TREE_WORK_ORDER_ID: (id) => {
    return `/link-tree/work-orders/${id}/create`;
  },
  LINK_TREE_ID: (id) => {
    return `/link-tree/detail/${id}`;
  },
  LINK_TREE_WORK_ORDER_LIST_ID: (id) => {
    return `/link-tree/detail/${id}/work-orders`;
  },
  LINK_TREE_WORK_ORDER: '/link-tree/work-orders',
  LINK_TREE_CHARGE_APPROVAL_LIST_ID: (id) => {
    return `/link-tree/detail/${id}/charge-approval`;
  },
  LINK_TREE_CHARGE_APPROVAL_ID: (id) => {
    return `/link-tree/charge-approval/${id}/create`;
  },
  LINK_TREE_CHARGE_APPROVAL: '/link-tree/charge-approval',
  LINK_TREE: '/link-tree',
  FORM_PENERIMAAN: (id) => {
    return `/form-penerimaan/${id}`;
  },
  HOME: '/',
};
